import { SERVER } from "../constants";
import { HttpClient, SaveImage, SaveFile } from "../utils/requests";
import { MAP_URL } from "../constants/urls";
import { fixCreateAdminUsersId } from "../panels/adminUsers/adminUsersMapper";
import { fixCreatePaybillsId } from "../panels/hr/paybills/paybillsMapper";
import { fixCreateInsertPaybillId } from "../panels/hr/insertPaybill/insertPaybillMapper";
import { fixCreateRequestId } from "../panels/hr/requests/requestsMapper";


export async function createOne(resource, params) {
  if (params.data.pictures) {
    await SaveImage(resource, params)
  }
  if (params.data.attachfile) {
    await SaveFile(resource, params)
  }

  return HttpClient(`${SERVER}/${MAP_URL[resource]}`, {
    method: "POST",
    body: JSON.stringify(params.data),
  }).then(({ json }) => {
    if (resource === 'insertPaybill') {
      return fixCreateInsertPaybillId(params, json);
    } else if (resource === 'paybills') {
      return fixCreatePaybillsId(params, json);

    } else if (resource === 'adminUsers') {
      return fixCreateAdminUsersId(params, json);
    } else if (resource === 'request') {
      return fixCreateRequestId(params, json);
    }
    return {
      data: { ...params.data, id: json.objectId },
    };
  }
  );
}